

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Select2OptionData } from 'ng-select2';
import { ToastrService } from 'ngx-toastr';
import { CreateResult } from '../models/create-result';
import { ParticipantViewModel } from '../models/participant-view-model';
import { ParticipantService } from '../services/participant.service';
import { UserDataStoreService } from '../services/user-data-store.service';
import { PermissionEnum } from '../services/guards/permissions';
import { VASService } from '../services/vas.service';
import { VasConfigurationViewModel } from '../models/vas-configuration-view-model';


@Component({
  selector: 'vas-configuration-mapping-view',
  templateUrl: './vas-configuration-view.component.html',
  styleUrls: ['./vas-configuration-view.component.scss']
})
export class VasConfigurationViewComponent implements OnInit {

  public serviceTypes: Select2OptionData[];
  public mapServiceTypes: Select2OptionData[];

  public providers: Select2OptionData[];
  public mapProviders: Select2OptionData[];

  public participant: ParticipantViewModel;

  public createResult: CreateResult;
  public canEdit: boolean;
  errorMessage: string;
  error: boolean;

  public ServiceType: number;
  public Provider: number;
  public VASRefNr: string;
  public Commission: string;
  public participantID: number;
  public vasConfigViewModel: VasConfigurationViewModel;

  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  constructor(
    private _participantService: ParticipantService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _route: ActivatedRoute,
    private _vasService: VASService) {
    this._route.params.subscribe(async params => {

      this.participantID = Number(params.id);
      this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditParticipantConfiguration], []);
      await this.initParticipant(params.id);

      this.serviceTypes = (await this._vasService.GetServicesTypes()).map((x) => {

        return { id: x.serviceTypeID.toString(), text: x.serviceTypeDescription.toString() }
      });

      this.providers = (await this._vasService.GetProviders()).map((x) => {

        return { id: x.providerID.toString(), text: x.providerName.toString() }
      });

      //get a Commission config

      this.vasConfigViewModel = await _vasService.GetCommissionConfig(this.participantID);

      this.ServiceType = this.vasConfigViewModel.serviceTypeID;
      this.Provider = this.vasConfigViewModel.providerID;
      this.Commission = this.vasConfigViewModel.commission.toString().replace(".", ",");
      this.VASRefNr = this.vasConfigViewModel.vasRefNr;

    });
  }

  public async ngOnInit(): Promise<void> {

  }

  public async initParticipant(id: number): Promise<void> {
    this.participant = await this._participantService.GetParticipant(id);
  }

  public async save(): Promise<void> {

    if (!this.canEdit) {
      this._toastService.error('You do not have the required permissions to perform this action.', 'Error');
    } else {



      this.vasConfigViewModel = {
        participantID: this.participantID,
        commission: this.Commission,
        providerID: Number(this.Provider),
        serviceTypeID: Number(this.ServiceType),
        vasRefNr: ""+this.VASRefNr
      }
      this.createResult = await this._vasService.Update(this.vasConfigViewModel);
      if (this.createResult.success) {
        this._toastService.success(this.createResult.message, 'Success');
      } else {
        this._toastService.error(this.createResult.message, 'Error');
      }

    }
  }

  public omit_special_char(event) {

    if (!!event) {
      var k;
      k = event.charCode;//         k = event.keyCode;  (Both can be used)

      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 42 || k == 44);
    }
  }

}

